<ng-container [formGroup]="formGroup">
    <div class="container content">
        <div class="row">
            <div class="col-lg-10 offset-md-1">
                <h5 class="title-step text-center" >
                    <img src="./assets/img/refresh-cw.svg" class="img-fluid ico-title" width="20"> Duplicado
                </h5>
                <div class="card">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item cuerpo-pack">
                            <div class="row pt-2">
                                <div [class]="classColumn">
                                    <digo-select
                                        id="province"
                                        [label]="'Motivo del cambio'"
                                        [options]="master?.reason"
                                        [formGroup]="formGroup"
                                        controlName="reason"
                                        optionValue="reason_id"
                                        optionLabel="value"
                                        [isRequired]="true"
                                    />
                                </div>
                                <div class="col-lg-2" *ngIf="permSv.hasPermFromV2(allPermissions.simyo.permite_sell_esim)">
                                    <digo-select
                                        id="province"
                                        [label]="'Tipo de tarjeta'"
                                        [options]="cardType"
                                        [formGroup]="formGroup"
                                        controlName="is_esim"
                                        optionValue="is_esim"
                                        optionLabel="text"
                                        [isRequired]="true"
                                        (OnChange)="changeTypeCard($event.target.value)"
                                    />
                                </div>
                                <div class="col-lg-4" *ngIf="formGroup.get('is_esim').value == typeCard.sim">
                                    <!-- <mat-form-field>
                                        <mat-label>Nº <b>nueva</b> tarjeta SIM (ICC-ID)</mat-label>
                                        <input matInput type="text" formControlName="iccid" required (change)="isValidIccid('iccid')" (input)="isValidIccid('iccid')" maxlength="19" minlength="19">
                                        <mat-hint class="text-end">{{ formGroup.get('iccid').value?.length }} / 19</mat-hint>
                                        <mat-error *ngIf="formGroup.get('iccid')?.errors?.iccid && !formGroup.get('iccid')?.errors?.required">
                                            ICCID formato incorrecto
                                        </mat-error>
                                        <mat-error *ngIf="formGroup.get('iccid')?.errors?.required">
                                            Campo obligatorio.
                                        </mat-error>
                                        <mat-error *ngIf="formGroup.get('iccid')?.errors?.used">
                                            ICCID en uso, utiliza otra sim
                                        </mat-error>
                                        <mat-error *ngIf="formGroup.get('iccid')?.errors?.invalid">
                                            ICCID no es válido
                                        </mat-error>
                                    </mat-form-field> -->

                                      <div class="position-relative">
                                        <digo-input
                                            id="iccid_client"
                                            class="w-100 pe-5"
                                            label="Nº nueva tarjeta SIM (ICC-ID)"
                                            [formGroup]="formGroup"
                                            controlName="iccid"
                                            [maxlength]="19"
                                            [minlength]="19"
                                            type="text"
                                            (input)="isValidIccid('iccid')"
                                            (change)="isValidIccid('iccid')"
                                            [isRequired]="true"
                                        ></digo-input>
                                        <a class="position-absolute translate-middle-y end-0" style="top: 25px;"
                                            (click)="openModal(ICCID)"
                                            title="¿Dónde encuentro el ICCID?">
                                            <img src="./assets/img/info.svg" class="img-fluid" width="20">
                                        </a>
                                        <mat-hint class="iccid-hint-ds d-block">
                                            {{ formGroup.get('iccid').value?.length }} / 19
                                        </mat-hint>
                                    </div>
                                </div>

                                <div [class]="classColumn">
                                    <digo-input
                                            id="portability_phone"
                                            label="Nº de teléfono (MSISDN)"
                                            [formGroup]="formGroup"
                                            controlName="msisdn"
                                            [maxlength]="9"
                                            type="text"
                                            (keypress)="numberOnly($event)"
                                            (paste)="validatePasteMsisdn($event)"
                                            [isRequired]="true"
                                        />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container content">
        <div class="row">
            <div class="col-lg-10 offset-md-1">
                <h5 class="title-step mt-5 text-center" >
                    <img src="./assets/img/users.svg" class="img-fluid ico-title" width="20"> Datos cliente
                </h5>
                <div class="card">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item cuerpo-pack">
                            <div class="row">
                                <div class="col-lg-3 mt-0">
                                    <digo-select
                                        id="doc"
                                        [label]="'Tipo documento'"
                                        [options]="master?.document_types" 
                                        [formGroup]="formGroup"
                                        controlName="documentType"
                                        optionValue="document_type_id"
                                        optionLabel="value"
                                        [isRequired]="true"
                                        (OnChange)="changeTypeDocument($event.target.value);setMaxLengthByDoc($event.target.value)"
                                     />
                                </div>
                                <div class="col-lg-3 mt-0">
                                   <!--  <mat-form-field>
                                        <mat-label>Nº de documento</mat-label>
                                        <input matInput type="text" formControlName="documentNumber"
                                        (input)="formGroup.get('documentNumber').patchValue(formGroup.get('documentNumber').value.toUpperCase());"
                                        [maxLength]="maxLengthByDoc" required (keypress)="alphanumericOnly($event)">
                                        <mat-error *ngIf="formGroup.get('documentNumber')?.errors?.required">
                                            Campo obligatorio.
                                        </mat-error>
                                        <mat-error *ngIf="(formGroup.get('documentNumber')?.errors?.doc || formGroup.get('documentNumber')?.errors?.pattern) && !formGroup.get('documentNumber')?.errors?.required">
                                            Número de documento erróneo
                                        </mat-error>
                                    </mat-form-field> -->
                                    <digo-input
                                            id="doc"
                                            label="Nº de documento"
                                            [isRequired]="true"
                                            [formGroup]="formGroup"
                                            controlName="documentNumber"
                                            [maxlength]="maxLengthByDoc"
                                            type="text"
                                            (OnKeyPress)="alphanumericOnly($event)"
                                            (input)="formGroup.get('documentNumber').patchValue(formGroup.get('documentNumber').value.toUpperCase())"
                                    />
                                </div>
                                <div class="col-lg-3 mt-0">
                                    <!-- <mat-form-field class="pt-1">
                                        <mat-label>Nacionalidad</mat-label>
                                        <select matNativeControl required formControlName="nationality">
                                            <ng-container *ngFor="let country of master?.countries">
                                                <option [value]="country.country_id" [hidden]="formGroup.get('documentType').value === '1' && country.country_id === 192">
                                                    {{ country.value }}
                                                </option>
                                            </ng-container>
                                        </select>
                                        <mat-error *ngIf="formGroup.get('nationality')?.errors?.required">
                                            Campo obligatorio.
                                        </mat-error>
                                    </mat-form-field> -->
                                    <digo-select
                                        [label]="'Nacionalidad'"
                                        [options]="master?.countries" 
                                        [formGroup]="formGroup"
                                        controlName="nationality"
                                        optionValue="country_id"
                                        optionLabel="value"
                                        [isRequired]="true"
                                    />
                                </div>
                                <div class="col-lg-3 mt-0">
                                    <!-- <mat-form-field class="pt-1">
                                        <mat-label>Sexo</mat-label>
                                        <select matNativeControl formControlName="gender" required>
                                            <option *ngFor="let sex of master?.genders" [value]="sex.gender_id">
                                                {{ sex.value }}
                                            </option>
                                        </select>
                                        <mat-error *ngIf="formGroup.get('gender')?.errors?.required">
                                            Campo obligatorio.
                                        </mat-error>
                                    </mat-form-field> -->
                                    <digo-select
                                        id="gender"
                                        [label]="'Sexo'"
                                        [options]="master?.genders"
                                        [formGroup]="formGroup"
                                        controlName="gender"
                                        optionValue="gender_id"
                                        optionLabel="value"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 mt-0">
                                    <!-- <mat-form-field>
                                        <mat-label>Nombre</mat-label>
                                        <input matInput type="text" formControlName="name" required>
                                        <mat-error *ngIf="formGroup.get('name')?.errors?.required">
                                            Campo obligatorio.
                                        </mat-error>
                                    </mat-form-field> -->
                                    <digo-input
                                            id="firstName"
                                            label="Nombre"
                                            [isRequired]="true"
                                            [formGroup]="formGroup"
                                            controlName="name"
                                            [maxlength]="32"
                                            type="text"
                                    />
                                </div>
                                <div class="col-lg-3 mt-0">
                                   <!--  <mat-form-field>
                                        <mat-label>Apellido1</mat-label>
                                        <input matInput type="text" formControlName="lastName1" required>
                                        <mat-error *ngIf="formGroup.get('lastName1')?.errors?.required">
                                            Campo obligatorio.
                                        </mat-error>
                                    </mat-form-field> -->
                                    <digo-input
                                            id="firstName"
                                            label="Apellido1"
                                            [isRequired]="true"
                                            [formGroup]="formGroup"
                                            controlName="lastName1"
                                            [maxlength]="64"
                                            type="text"
                                    />
                                </div>
                                <div class="col-lg-3 mt-0">
                                   <!--  <mat-form-field>
                                        <mat-label>Apellido2</mat-label>
                                        <input matInput type="text" formControlName="lastName2">
                                    </mat-form-field> -->
                                    <digo-input
                                            id="firstName"
                                            label="Apellido2"
                                            [formGroup]="formGroup"
                                            controlName="lastName2"
                                            [maxlength]="64"
                                            type="text"
                                    />
                                </div>
                                <div class="col-lg-3 mt-0">
                                    <digo-datepicker
                                        id="birthday"
                                        label="Fecha de nacimiento"
                                        [formGroup]="formGroup"
                                        controlName="birthday"
                                        [minDate]="minDate"
                                        [maxDate]="maxDate"
                                        [isRequired]="true"
                                    />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- Continuar proceso -->
        <div class="row mt-4" *ngIf="!showDocSection">
            <div class="col-xl-10 offset-md-1">
                <div class="d-flex justify-content-center">
                    <br>
                    <button class="btn btn-simyo-o2 d-block w-100 mb-1 fw-bold" (click)="validatePersonalData()" [disabled]="isLoadingDraft" *ngIf="isValidMrz() || isLoadingDraft || isAllowToContinue">
                        Continuar <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15" *ngIf="!isLoadingDraft">
                        <span *ngIf="isLoadingDraft" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    </button>
                    <br><br>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #ICCID let-modal>
    <div class="modal-header bg-simyo-grey">
        <h5 class="modal-title white" id="exampleModalLabel">¿Dónde encuentro el ICCID?</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>
    <img src="./assets/img/iccid-simyo.png" class="img-fluid ico-title p-5">
</ng-template>
